//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { Check } from 'src/onboarding/components/ui/check/Check';
import { Option } from 'src/onboarding/components/ui/check/Option';
import cn from 'classnames';
import styles from './style.module.scss';
import pancakes from '../../assets/images/pancakesMenu.webp';
import crispBread from '../../assets/images/crispBread.webp';
import shakshuka from '../../assets/images/shakshuka.webp';
import almonds from '../../assets/images/almonds.webp';
import tuna from '../../assets/images/tuna.webp';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';

function Page() {
  const youGuessedCount = useStore((state) => state.youGuessedCount);

  const { onNext, currentIndex } = useNav();

  const menu = [
    {
      dishName: t('onboarding.youGuessed.menu.pancakes'),
      image: pancakes,
      mealType: t('onboarding.youGuessed.menu.breakfast'),
      kcal: '410 kcal',
    },
    {
      dishName: t('onboarding.youGuessed.menu.crispBread'),
      image: crispBread,
      mealType: t('onboarding.youGuessed.menu.snack'),
      kcal: '190 kcal',
    },
    {
      dishName: t('onboarding.youGuessed.menu.shakshuka'),
      image: shakshuka,
      mealType: t('onboarding.youGuessed.menu.lunch'),
      kcal: '250 kcal',
    },
    {
      dishName: t('onboarding.youGuessed.menu.almonds'),
      image: almonds,
      mealType: t('onboarding.youGuessed.menu.snack'),
      kcal: '140 kcal',
    },
    {
      dishName: t('onboarding.youGuessed.menu.tuna'),
      image: tuna,
      mealType: t('onboarding.youGuessed.menu.dinner'),
      kcal: '300 kcal',
    },
  ];

  return (
    <div className='page' style={{ gap: '20px', paddingBottom: '90px' }}>
      <div className='wrapper-info'>
        <Title tag='h2'>
          {t('onboarding.youGuessed.title', { VALUE: String(youGuessedCount) })}
        </Title>
      </div>

      <div className={styles.menu}>
        {menu.map((item, idx) => (
          <div className={styles.card} key={idx}>
            <div className={styles.imgWrapper}>
              <img src={item.image} alt='img' />
            </div>

            <Text size='m' bold className={styles.cardHeader}>
              {item.dishName}
            </Text>
            <div className={styles.mealDetails}>
              <Text semibold size='s' className={styles.mealType}>
                {item.mealType}
              </Text>
              <Caption size='m' className={styles.mealKcal}>
                {item.kcal}
              </Caption>
            </div>
          </div>
        ))}
      </div>
      <div className='wrapper-info'>
        <div className={styles.message}>
          <Text size='m' medium>
            {t('onboarding.youGuessed.menuDescription.start')} <span>1290 kcal</span>{' '}
            {t('onboarding.youGuessed.menuDescription.middle')}
          </Text>
          <Text size='m' medium>
            {t('onboarding.youGuessed.menuDescription.end')} 🎯
          </Text>
        </div>
      </div>
      <div className={'overlay'}></div>
      <div className={'next-wrapper'}>
        <Button
          title={t('onboarding.youGuessed.continue')}
          onClick={() => {
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'you-guessed',
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}

export default Page;
